export default __webpack_public_path__ + "static/media/valores.3dcb01c5.png";